export const MEDIA_BREAKPOINTS = [640, 768, 1024, 1280, 1800];

export const mediaQueries = MEDIA_BREAKPOINTS.map(
	(bp) => `@media (min-width: ${bp}px)`,
);
